export default __webpack_public_path__ + "87008066c6b25335a9647e90bbf10f7e.png";